module.exports = {"data":{"site":{"siteMetadata":{"title":"Razy Technologies"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/leveraging-cloud-services-results-in-seamless-distribution-of-lubricant-oil-in-mena/"},"frontmatter":{"title":"Leveraging Cloud Services Results in Seamless Distribution of Lubricant Oil in MENA"}}}]}},"pathContext":{"tag":"loyalty"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-loyalty.json
// module id = 469
// module chunks = 62412615829541